
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/bloomreach",
      function () {
        return require("private-next-pages/destinations/bloomreach.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/bloomreach"])
      });
    }
  